import { isVerum } from "../../../utils/misc";
import { InfometeosLogo, VerumDarkLogo } from "../Logotypes";
import styles from "./Title.module.scss";

export const Title = () => {
  return <h1 className={styles.title}>{isVerum() ? <VerumDarkLogo /> : <InfometeosLogo />}</h1>;
};
